import { s as script$1 } from './Checkbox-o2PhGepR.js';
import { C as CheckRadioMixin } from './CheckRadioMixin-I9QgrPGQ.js';
import { openBlock, createElementBlock, normalizeClass, createElementVNode, withKeys, withModifiers, renderSlot, withDirectives, vModelCheckbox } from 'vue';
import { a as registerComponent } from './plugins-C7548x21.js';

var script = {
    name: 'BCheckboxButton',
    mixins: [CheckRadioMixin],
    props: {
        type: {
            type: String,
            default: 'is-primary'
        },
        expanded: Boolean
    },
    data() {
        return {
            isFocused: false
        }
    },
    computed: {
        checked() {
            if (Array.isArray(this.newValue)) {
                return this.newValue.indexOf(this.nativeValue) >= 0
            }
            return this.newValue === this.nativeValue
        }
    }
};

const _hoisted_1 = ["disabled"];
const _hoisted_2 = ["disabled", "required", "name", "value"];

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("div", {
    class: normalizeClass(["control", { 'is-expanded': $props.expanded }])
  }, [
    createElementVNode("label", {
      class: normalizeClass(["b-checkbox checkbox button", [$options.checked ? $props.type : null, _ctx.size, {
                'is-disabled': _ctx.disabled,
                'is-focused': $data.isFocused
            }]]),
      ref: "label",
      disabled: _ctx.disabledOrUndefined,
      onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.focus && _ctx.focus(...args))),
      onKeydown: _cache[5] || (_cache[5] = withKeys(withModifiers($event => (_ctx.$refs.label.click()), ["prevent"]), ["enter"]))
    }, [
      renderSlot(_ctx.$slots, "default"),
      withDirectives(createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.computedValue) = $event)),
        type: "checkbox",
        ref: "input",
        onClick: _cache[1] || (_cache[1] = withModifiers(() => {}, ["stop"])),
        disabled: _ctx.disabledOrUndefined,
        required: _ctx.requiredOrUndefined,
        name: _ctx.name,
        value: _ctx.nativeValue,
        onFocus: _cache[2] || (_cache[2] = $event => ($data.isFocused = true)),
        onBlur: _cache[3] || (_cache[3] = $event => ($data.isFocused = false))
      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_2), [
        [vModelCheckbox, _ctx.computedValue]
      ])
    ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_1)
  ], 2 /* CLASS */))
}

script.render = render;
script.__file = "src/components/checkbox/CheckboxButton.vue";

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, script$1);
    registerComponent(Vue, script);
  }
};

export { script$1 as BCheckbox, script as BCheckboxButton, Plugin as default };
